import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS, CONTACT, SOCIALS, KMD } from "../../data";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const FacebookIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const YouTubeIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const LinkedInIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.119 20.452H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

const SOCIAL_STYLES = {
  facebook: { bg: "#1877F2" },
  instagram: { bg: "radial-gradient(circle at 30% 110%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)" },
  tiktok: { bg: "#010101" },
  youtube: { bg: "#FF0000" },
  linkedin: { bg: "#0A66C2" },
};

const SOCIAL_ICONS = { facebook: FacebookIcon, instagram: InstagramIcon, tiktok: TikTokIcon, youtube: YouTubeIcon, linkedin: LinkedInIcon };

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-[#bf953f]/15 bg-[#081226] pt-20 pb-10 overflow-hidden">
    <div className="absolute -top-1/4 right-0 h-[40vh] w-[40vh] rounded-full bg-[#bf953f]/10 blur-[140px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-14">
        <div>
          <img src={LOGO_URL} alt="Heritage Family Protection Agency" className="w-full max-w-xs h-auto object-contain" />
          <p className="mt-5 max-w-xs font-body font-light text-sm leading-relaxed text-white/45">
            Independent protection for life, health, mortgage, legal, retirement, and tax — all under one crest.
          </p>
          <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
            {SOCIALS.map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              const style = SOCIAL_STYLES[s.id];
              return (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${s.label}`}
                  data-testid={`footer-social-${s.id}`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full text-white transition-transform duration-300 hover:scale-110 hover:shadow-lg"
                  style={{ background: style.bg, border: s.id === "tiktok" ? "1px solid rgba(255,255,255,0.25)" : "none" }}
                >
                  <Icon size={18} />
                </a>
              );
            })}
          </div>
          <div className="mt-6 flex items-center gap-3 flex-wrap">
            <div
              data-testid="footer-konnectmd-logo"
              className="inline-flex items-center rounded-xl bg-white px-3 py-2 shadow-[0_4px_20px_rgba(0,0,0,0.35)]"
            >
              <img src={KMD.logo} alt="KonnectMD" className="h-6 md:h-7 w-auto object-contain" />
            </div>
            <Link
              to="/att"
              data-testid="footer-att-logo"
              className="inline-flex items-center rounded-xl bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.35)]"
            >
              <img src="/att/att-authorized-dealer.jpg" alt="AT&T Authorized Dealer" className="h-11 md:h-12 w-auto object-contain" />
            </Link>
          </div>
        </div>

        <div>
          <p className="font-body text-xs tracking-[0.25em] uppercase text-[#d4af37]">Navigate</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="font-body text-sm text-white/55 hover:text-[#fcf6ba] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
            <li key="/att">
              <Link to="/att" data-testid="footer-att-link" className="font-body text-sm font-semibold text-[#00A8E0] hover:text-[#7dd3fc] transition-colors">
                AT&T Services
              </Link>
            </li>
            <li key="/vivint">
              <Link to="/vivint" data-testid="footer-vivint-link" className="font-body text-sm font-semibold text-[#FF7A00] hover:text-[#ffb066] transition-colors">
                Vivint Home Security
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-body text-xs tracking-[0.25em] uppercase text-[#d4af37]">Contact</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="font-body text-sm text-white/55 hover:text-[#fcf6ba] transition-colors">
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={CONTACT.emailHref} data-testid="footer-email" className="font-body text-sm text-white/55 hover:text-[#fcf6ba] transition-colors">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="font-serif-display leading-none tracking-tight select-none flex flex-nowrap items-baseline gap-x-4 md:gap-x-8 whitespace-nowrap" style={{ fontSize: "clamp(2rem, 9vw, 8rem)" }}>
        <span className="text-gold-gradient">HERITAGE</span>
        <span className="italic text-white">protects</span>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8" data-testid="footer-disclaimer">
        <p className="font-body text-[11px] tracking-[0.25em] uppercase text-[#d4af37]/80">Website Disclaimer</p>
        <div className="mt-3 space-y-2.5 font-body font-light text-xs leading-relaxed text-white/40 max-w-5xl">
          <p>
            Heritage Family Protection Agency is not an insurance company and does not underwrite, issue, or insure
            insurance policies. We are an independent agency that helps connect individuals and families with insurance
            products and services offered by third-party licensed insurance carriers.
          </p>
          <p>
            Heritage Family Protection Agency is also not a law firm and does not provide legal advice or legal
            representation. We offer access to LegalShield legal service membership plans, which are provided by
            independent provider law firms through LegalShield.
          </p>
          <p>
            All coverage, policy terms, conditions, pricing, availability, and approval decisions are determined solely
            by the issuing insurance company. Heritage Family Protection Agency does not guarantee coverage or carrier
            approval.
          </p>
          <p>Please review all policy documents and carrier materials carefully for complete details.</p>
          <p>For questions, please contact us directly for more information.</p>
        </div>
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="font-body text-xs text-white/40">
          © {new Date().getFullYear()} Heritage Family Protection Agency. All rights reserved.
        </p>
        <p className="font-body text-xs italic text-white/40">Protecting Families · Preserving Legacies.</p>
      </div>
    </div>
  </footer>
);
